export default __webpack_public_path__ + "static/media/Murata Machinery.0c2a524c.png";